<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Terminal de Venda
        </span>
      </h3>
    </div>
    <Form url="/terminalVenda/create" :terminal="terminal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import TerminalData from "./TerminalData";

export default {
  name: "app-terminal-create",
  data() {
    return {
      terminal: new TerminalData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
